<template>
  <div v-focusable class="user-icon-with-modal__wrapper" @click="onClick">
    <a-user-icon :is-active="isUserMenuVisible" />

    <a-modal-widget
      v-model="isUserMenuVisible"
      :activator-selector="$options.consts.USER_ICON_SELECTOR"
      :right="0"
      :top-offset="modalWidgetTopOffset"
      :show-social-networks="false"
      :scroll-to-top="false"
      :scroll-top="-57"
      class="user-icon-with-modal__modal-widget"
      :with-tablet-layout="false"
    >
      <a-user-menu class="user-icon-with-modal__user-menu" />
    </a-modal-widget>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import AModalWidget from '@/components/_modals/AModalWidget'
import AUserMenu from '../AUserMenu'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import {
  ACTIVATOR_ID,
  ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID
} from 'enums/activator-id'
import { ICON } from 'shared/AIcon/index.vue'
import AUserIcon from '@/components/AHeader/Shared/AUserIconWithModalWidget/AUserIcon/index.vue'

export default {
  name: 'AUserIconWithModalWidget',
  mixins: [mixins.urlFormatters, hydrationHelpers],
  components: { AUserIcon, AModalWidget, AUserMenu },
  consts: {
    USER_ICON_SELECTOR: ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID[ACTIVATOR_ID.AUTH],
    ICON
  },
  data() {
    return {
      isUserMenuVisible: false
    }
  },
  computed: {
    modalWidgetTopOffset() {
      return this.$_hydrationHelpers_mobileOrDesktopValue(0, 55)
    }
  },
  methods: {
    onClick() {
      this.isUserMenuVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.user-icon-with-modal__wrapper {
  position: relative;
  cursor: pointer;

  .user-icon-with-modal__modal-widget {
    width: 230px;

    @include mobile {
      width: 100%;
      border: 0;
    }
  }

  .user-icon-with-modal__user-menu {
    padding: 32px;

    @include mobile {
      padding: 40px 0 20px 0;
    }
  }
}
</style>
